import { ModuleFE_Referencable } from './ModuleFE_Referencable.js';
export const ModulePackFE_ReferencableDB = [ModuleFE_Referencable];
//# sourceMappingURL=module-pack.js.map